import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=best-mission-save data-testid=best-mission-save role=dialog aria-label="Enter Best Missions name"><div class=best-mission-save__panel><p class=best-mission-save__eyebrow>BEST MISSIONS · </p><h2 class=best-mission-save__headline>WHAT IS YOUR PILOT'S NAME?</h2><p class=best-mission-save__note>MISSION SCORE <!> PLACES ON THE BEST MISSIONS LISTING</p><label class=best-mission-save__field><span>PILOT NAME</span><input type=text class=best-mission-save__input data-testid=best-mission-save-name autocomplete=off></label><div class=best-mission-save__actions><button type=button class=best-mission-save__button>CANCEL</button><button type=button class="best-mission-save__button best-mission-save__button--primary"data-testid=best-mission-save-confirm>OKAY`);
import { createSignal } from "solid-js";

/**
 * The manual's own moment: *"If you do well in your mission review, you may
 * have a chance to enter your name in the Best Missions top 10 listing"*
 * (`docs/game/manual/04-gameplay.md`) — this pops the instant a qualifying
 * score is credited, unprompted, exactly like the manual describes it. The
 * question itself, `WHAT IS YOUR PILOT'S NAME?`, is `PS.EXE`'s own verbatim
 * string, shared with the career enlistment dialog (`career-screens.ts`'s
 * `enlistScreen`) — a single mission has no persistent pilot to draw a name
 * from, so it is typed in fresh, same as the original asked for one there.
 */
export function BestMissionPrompt(props) {
  const [name, setName] = createSignal("");
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$3.nextSibling,
      _el$6 = _el$5.nextSibling,
      _el$7 = _el$6.firstChild,
      _el$9 = _el$7.nextSibling,
      _el$8 = _el$9.nextSibling,
      _el$0 = _el$6.nextSibling,
      _el$1 = _el$0.firstChild,
      _el$10 = _el$1.nextSibling,
      _el$11 = _el$0.nextSibling,
      _el$12 = _el$11.firstChild,
      _el$13 = _el$12.nextSibling;
    _$insert(_el$3, () => props.missionTitle, null);
    _$insert(_el$6, () => props.score, _el$9);
    _el$10.$$input = event => setName(event.currentTarget.value);
    _$setAttribute(_el$10, "spellcheck", false);
    _el$12.$$click = () => props.onCancel();
    _el$13.$$click = () => props.onSave(name());
    _$effect(() => _el$10.value = name());
    return _el$;
  })();
}
_$delegateEvents(["input", "click"]);